import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

export const videoPlayerAdaptor = createEntityAdapter();

export interface VideoPlayerStateType {
  loaded: boolean;
  options: any;
  vocamVideoLink?: string;
  vocamVideoLinkLoaded: boolean;
}

const initialState: VideoPlayerStateType = videoPlayerAdaptor.getInitialState({
  loaded: false,
  options: [],
  vocamVideoLink: undefined,
  vocamVideoLinkLoaded: false,
});

const videoPlayerSlice = createSlice({
  name: 'videoPlayer',
  initialState,
  reducers: {
    getVideoOptions: (state, action) => {
      state.loaded = false;
      state.options = [];
      if (action.payload.options.length) {
        state.options = action.payload.options;
        state.loaded = action.payload.loaded;
      }
    },
    // TODO: Add vocamvideo link
    getVocamVideoLink: (state, action) => {
      state.vocamVideoLinkLoaded = false;
      state.vocamVideoLink = undefined;
      if (action.payload.vocamVideoLink) {
        state.vocamVideoLink = action.payload.vocamVideoLink;
        state.vocamVideoLinkLoaded = action.payload.vocamVideoLinkLoaded;
      }
    },
  },
});

export const { name, actions, reducer } = videoPlayerSlice;
